import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getSalesReportWithNotes, getSalesReportWithNotesGrandTotal, downloadExcelSalesReportWithNotes } from '@/api/reports';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery } from '@/utils/index';
import Inr from '@/components/Inr/index.vue';
import { getAdmins } from '@/api/admins';
import { getAgentById } from '@/api/agents';
import { searchDealers } from '@/api/dealers';
import { AdminModule } from '@/store/modules/admin';
import { getStates } from '@/api/locations/states';
import { getCities } from '@/api/locations/cities';
import { BranchAgentService } from '@/services/branch-agent-service';
import { cleanListQuery, isAdmin, isBranchManager, isSuperAdmin, isZonalManager, isReadOnly } from '@/common';
import moment from 'moment';
import { BRANCH_MANAGER, ZONAL_MANAGER } from '@/constants/roles.constants';
import * as XLSX from 'xlsx';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.total = 0;
    this.list = [];
    this.listLoading = false;
    this.downloadLoading = false;
    this.grandTotalLoading = false;
    this.grandTotal = {
      totalAmount: 0,
      totalPreTaxedValue: 0,
      specialDiscountTotal: 0,
      creditNoteItemWiseTotal: 0,
      replacementsTotal: 0,
      debitNoteItemWiseTotal: 0,
      creditNoteVoucherTotal: 0,
      debitNoteVoucherTotal: 0,
      netSales: 0
    };
    this.dateRange = '';
    this.branchList = [];
    this.isAgent = false;
    this.agentList = [];
    this.agentUserList = [];
    this.dealerList = [];
    this.stateList = [];
    this.cityList = [];
    this.dealerListLoading = false;
    this.cityListLoading = false;
    this.assignedBranches = [] || null;
    this.salesExecutiveAdmins = [];
    this.zonalManagerAdmins = [];
    this.selectedColumns = [];
    this.showDealerCode = false;
    this.showDealerCity = false;
    this.showDealerState = false;
    this.showSalesExecutiveAgent = false;
    this.showFilters = false;
    this.loggedInAdmin = null;
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: undefined,
      agentId: undefined,
      agentUserId: undefined,
      stateId: undefined,
      cityName: undefined,
      startDate: undefined,
      endDate: undefined,
      excludeBranches: false,
      'assignedAgents.id': undefined,
      "['mappedAdmin.id']": undefined,
      "['zonalAdmin.id']": undefined,
      branchId: [],
      sort: 'dealer_id,ASC'
    };
    this.columnOptions = [{
      label: 'Dealer Code',
      key: 'Dealer Code'
    }, {
      label: 'City',
      key: 'City'
    }, {
      label: 'State',
      key: 'State'
    }, {
      label: 'Sales Executive Agent',
      key: 'Sales Executive Agent'
    }];
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
    this.getAdminByRole = (mappedAdmins, roleName) => {
      try {
        if (!mappedAdmins || !Array.isArray(mappedAdmins)) return 'N/A';
        const admin = mappedAdmins.find(admin => {
          var _admin$roles;
          return admin === null || admin === void 0 || (_admin$roles = admin.roles) === null || _admin$roles === void 0 ? void 0 : _admin$roles.some(role => (role === null || role === void 0 ? void 0 : role.name) === roleName);
        });
        return admin ? admin.fullName : 'N/A';
      } catch (err) {
        return 'Error';
      }
    };
  }
  isSalesExecutiveAdmin() {
    return isBranchManager();
  }
  isZonalManagerAdmin() {
    return isZonalManager();
  }
  _isAdminRoles() {
    return isSuperAdmin() || isAdmin() || isReadOnly();
  }
  onCheckboxChange(value) {
    this.listQuery.excludeBranches = value;
  }
  async fetchSalesExecutiveManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [BRANCH_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.salesExecutiveAdmins = allManagers.data;
  }
  async fetchZonalAdminManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [ZONAL_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.zonalManagerAdmins = allManagers.data;
  }
  async activated() {
    try {
      this.listQuery.excludeBranches = true;
      this.assignedBranches = await BranchAgentService.assignBranchId();
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      this.loggedInAdmin = AdminModule;
      if (this.loggedInAdmin.userType === 'Agent') {
        this.isAgent = true;
        this.listQuery.agentId = this.loggedInAdmin.agentId;
        this.listQuery.agentUserId = this.loggedInAdmin.id;
        if (this.loggedInAdmin.roles.includes('Owner')) {
          this.listQuery.agentUserId = null;
        }
      }
      if (this.$route.query.startDate && this.$route.query.endDate) {
        this.dateRange = {
          start: this.$route.query.startDate,
          end: this.$route.query.endDate
        };
      } else {
        await this.getCurrentFinancialYear();
      }
      this.listQuery = {
        ...this.listQuery,
        ...this.$route.query
      };
      this.fetchSalesExecutiveManagers();
      this.fetchZonalAdminManagers();
      this.getStateList();
      this.getList();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  async getCurrentFinancialYear() {
    const currentDate = moment();
    let startYear = currentDate.year();
    if (currentDate.month() <= 2) {
      startYear--;
    }
    this.dateRange = {
      start: moment([startYear, 3, 1]),
      end: moment([startYear + 1, 3, 1]).subtract(1, 'days')
    };
    this.listQuery.startDate = this.dateRange.start;
    this.listQuery.endDate = this.dateRange.end;
  }
  buildQuery() {
    const query = cleanListQuery({
      ...this.listQuery
    });
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      query.startDate = this.dateRange.start;
      query.endDate = this.dateRange.end;
    }
    return query;
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery = cleanListQuery(this.listQuery);
      const query = this.buildQuery();
      const data = await getSalesReportWithNotes(query);
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
    this.getGrandTotal();
  }
  async getGrandTotal() {
    try {
      this.grandTotalLoading = true;
      const query = this.buildQuery();
      delete query.page;
      delete query.limit;
      this.grandTotal = await getSalesReportWithNotesGrandTotal(query);
      this.grandTotalLoading = false;
    } catch (error) {
      this.grandTotalLoading = false;
    }
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getStateList() {
    try {
      this.stateList = await getStates(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getCityList(stateId = 0) {
    try {
      this.cityListLoading = true;
      this.cityList = await getCities(getQuery({
        enabled: true,
        stateId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          stateId: '$eq'
        }
      }));
      this.cityListLoading = false;
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.listQuery.stateId) {
      this.showDealerState = true;
      this.showDealerCity = true;
      this.getCityList(this.listQuery.stateId);
    } else {
      this.showDealerCity = false;
      this.cityList = [];
      this.listQuery.cityName = undefined;
    }
    if (this.listQuery.agentId) {
      const agentData = await getAgentById(this.listQuery.agentId);
      this.agentUserList = agentData.agentUser.filter(user => user.roles.some(role => role.name === 'Sales Executive'));
    } else {
      this.agentUserList = [];
      this.listQuery['assignedAgents.id'] = undefined;
    }
    this.listQuery.page = 1;
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      this.getList();
    } else {
      this.getList();
    }
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop}` + (order === 'ascending' ? ',ASC' : ',DESC');
      this.handleFilter();
    }
  }
  handleVisibleColumns(data) {
    this.showDealerCode = data.includes('Dealer Code');
    this.showDealerCity = data.includes('City');
    this.showDealerState = data.includes('State');
    this.showSalesExecutiveAgent = data.includes('Sales Executive Agent');
  }
  async appendManagerColumns(blob, allData) {
    const getRole = (mappedAdmins, roleName) => {
      if (!mappedAdmins || !Array.isArray(mappedAdmins)) return '';
      const admin = mappedAdmins.find(a => {
        var _a$roles;
        return a === null || a === void 0 || (_a$roles = a.roles) === null || _a$roles === void 0 ? void 0 : _a$roles.some(r => (r === null || r === void 0 ? void 0 : r.name) === roleName);
      });
      return admin ? admin.fullName : '';
    };
    const dealerMap = new Map();
    for (const row of allData) {
      const key = String(row.dealerName || row.dealer_name || row.dealer_id || '');
      if (key) dealerMap.set(key, row.mappedAdmins);
    }
    const arrayBuffer = await blob.arrayBuffer();
    const wb = XLSX.read(arrayBuffer, {
      type: 'array'
    });
    for (const sheetName of wb.SheetNames) {
      const ws = wb.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(ws, {
        header: 1
      });
      if (!data.length) continue;
      const headers = data[0];
      const dealerColIdx = headers.findIndex(h => ['Dealer', 'Dealer Name', 'dealer_name'].includes(String(h)));
      headers.push('Branch Manager', 'Zonal Manager');
      for (let i = 1; i < data.length; i++) {
        const row = data[i];
        const dealerKey = dealerColIdx >= 0 ? String(row[dealerColIdx] || '') : '';
        const admins = dealerMap.get(dealerKey);
        row.push(getRole(admins, 'Branch Manager'));
        row.push(getRole(admins, 'Zonal Manager'));
      }
      wb.Sheets[sheetName] = XLSX.utils.aoa_to_sheet(data);
    }
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });
    return new Blob([wbout], {
      type: 'application/octet-stream'
    });
  }
  async handleExcelDownload() {
    this.downloadLoading = true;
    try {
      const query = this.buildQuery();
      delete query.page;
      delete query.limit;
      const allQuery = {
        ...query,
        limit: 100000
      };
      const [blob, allDataResponse] = await Promise.all([downloadExcelSalesReportWithNotes({
        query
      }), getSalesReportWithNotes(allQuery)]);
      const modifiedBlob = await this.appendManagerColumns(blob, (allDataResponse === null || allDataResponse === void 0 ? void 0 : allDataResponse.data) || []);
      const url = window.URL.createObjectURL(modifiedBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'sales-report-with-notes.xlsx';
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      this.$message.error(await this.extractBlobErrorMessage(error));
    } finally {
      this.downloadLoading = false;
    }
  }
  // The Excel endpoint streams the workbook and reports errors (e.g. no
  // data found) as a JSON body on a non-2xx status. Since the request uses
  // responseType 'blob', axios delivers that JSON as an unreadable Blob on
  // error.response.data instead of parsed text - this reads it back out so
  // the real server message reaches the user.
  async extractBlobErrorMessage(error) {
    var _error$response;
    const data = error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data;
    if (data instanceof Blob) {
      try {
        const text = await data.text();
        const parsed = JSON.parse(text);
        if (parsed !== null && parsed !== void 0 && parsed.message) {
          return parsed.message;
        }
      } catch (e) {} // eslint-disable-line no-empty
    }
    return 'Error downloading Excel';
  }
  getSummaries(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    const sumKeys = ['totalAmount', 'totalPreTaxedValue', 'specialDiscountTotal', 'creditNoteItemWiseTotal', 'replacementsTotal', 'debitNoteItemWiseTotal', 'creditNoteVoucherTotal', 'debitNoteVoucherTotal', 'netSales'];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Page Total';
        return;
      }
      if (sumKeys.includes(column.property)) {
        const values = data.map(item => Number(item[column.property]) || 0);
        sums[index] = values.reduce((prev, curr) => prev + curr, 0).toFixed(2);
      } else {
        sums[index] = '';
      }
    });
    return sums;
  }
};
default_1 = __decorate([Component({
  name: 'SalesReportWithNotesList',
  components: {
    Pagination,
    Inr
  }
})], default_1);
export default default_1;